module.exports = __webpack_public_path__ + "static/media/existing_user_manual.e306a29a.pdf";